import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import { useSelector } from "react-redux";

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin: 25px 0;
  border-bottom: 2px solid #d0d0d0;
`;

const Tbody = styled.tbody`
  tr:nth-of-type(odd) {
    background: #eee;
  }
`;

const Tr = styled.tr`
  &:first-of-type {
    td {
      border-top: 2px solid #d0d0d0;
    }
  }
`;

const Th = styled.th`
  &:first-of-type {
    padding: 0 0 5px 10px;
  }
`;

const Td = styled.td`
  &:first-of-type {
    padding: 0 0 0 10px;
  }
`;

const OrderCardsList = ({ cards = null }) => {
  const cartCards = useSelector((state) => state.Cart.cart.cards);
  const formatCurrency = (amount) =>
    new Intl.NumberFormat("en-US", {
      currencySign: "accounting",
      style: "currency",
      currency: "USD",
    }).format(amount);

  if (cards && cartCards && cards.length) {
    let renderCardsRows = cards
      .sort((a, b) => {
        return b.merchantName.toLowerCase() > a.merchantName.toLowerCase()
          ? -1
          : 1;
      })
      .map((card) => {
        const {
          id,
          merchantName,
          pin,
          refID,
          number,
          enteredValue,
          sellPercentage,
        } = card;
        const sellPrice = enteredValue * (sellPercentage / 100);
        // const { number } = cartCards.filter((card) => card.id === id)[0];

        return (
          <Tr key={id}>
            <Td>{merchantName}</Td>
            <Td>{number ? `xxxx${number}` : "N/A"}</Td>
            <Td>{pin}</Td>
            <Td>{refID}</Td>
            <Td>{formatCurrency(enteredValue)}</Td>
            <Td>{`${sellPercentage}%`}</Td>
            <Td>{formatCurrency(sellPrice)}</Td>
          </Tr>
        );
      });

    return (
      <Table>
        <thead>
          <Tr>
            <Th>Merchant</Th>
            <Th>Gift Card Number</Th>
            <Th>PIN</Th>
            <Th>RefID</Th>
            <Th>Face Value</Th>
            <Th>Sell %</Th>
            <Th>Sell Price</Th>
          </Tr>
        </thead>
        <Tbody>{renderCardsRows}</Tbody>
      </Table>
    );
  }

  return null;
};

OrderCardsList.prototype = {
  cards: PropTypes.array.isRequired,
};

export { OrderCardsList };
